import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PremiumLayoutSkeleton } from "../page-skeleton";
import { ENTERPRISE_ROLE } from "../../constant";
import SubscriptionCard from "./subscription-card";
import CompanyCard from "./company-card";
import FirstTimeModal from "../../pages/leads/pages/dashboard/components/modal";
import "./styles.scss";

function PremiumLayout({ children }) {
  // STATES
  const [loading, setLoading] = useState(true);
  const [isSubscribed, setSubscribed] = useState(true);
  const [hasCompany, setHasCompany] = useState(false);

  // REDUX DATA
  const user = useSelector((state) => state.UserReducer.profile);
  const companies = useSelector((state) => state.CompanyReducer.companies);

  // CONST VALS
  const history = useHistory();

  // HOOKS
  useEffect(() => {
    if (!user) return;
    // TODO: uncomment this when we restrict professional users from accessing enterprise features
    // if (user?.role === ENTERPRISE_ROLE) {
      setLoading(false);
      setHasCompany(companies?.length > 0);
    // } else {
    //   if (history.location.pathname.includes("leads-manager")) {
    //     setHasCompany(true);
    //     setLoading(false);
    //     return;
    //   }
    //   history.push("/dataset");
    // }
  }, [user, companies]);

  return (
    <div className="pre-wrapper">
      {loading ? (
        <div className="loading">
          <PremiumLayoutSkeleton />
        </div>
      ) : !isSubscribed ? (
        <SubscriptionCard />
      ) : !hasCompany ? (
        <CompanyCard />
      ) : (
        children
      )}
      {!hasCompany && <FirstTimeModal />}
    </div>
  );
}

export default PremiumLayout;
